import { useConfig } from './useConfig';

/**
 * The shop's ISO 4217 currency code from the storefront config, with a USD
 * fallback for configs cached before the field existed.
 */
export const useShopCurrency = (): string => {
    const config = useConfig();
    return config?.shopConfig?.shop?.currencyCode || 'USD';
};
